export default __webpack_public_path__ + "static/media/logo_swood.89835167.svg";